export const CHECKLIST_ITEMS = {
  TWO_FACTOR: "TWO_FACTOR",
  BANKING: "BANKING",
  TAX_DOCS: "TAX_DOCS",
  PAYMENT_TERMS: "PAYMENT_TERMS",
  INVOICING: "INVOICING",
} as const;

export type ChecklistItemType = ObjectValues<typeof CHECKLIST_ITEMS>;
